import React from 'react';
import { Loader } from '../Common/Loader';
import { WebCamSwitch } from '../WebCamSwitch';
import { VideoType } from '_helpers';
import cn from 'classnames';
import styles from './UserVideo.module.scss';
import ExclamationIcon from './exclamation.svg';
import FullScreenIcon from './full-screen-icon.png';

const UserVideo = ({
    processing,
    videoStream,
    containerClassName,
    muted,
    camSwitch,
    onSwitch,
    videoType,
    connectionLost,
    withoutFullScreen,
    ...props
}: UserVideoPropsType) => {
    const ref = React.useRef<HTMLVideoElement>(null);
    const isWebCam = videoType === VideoType.Cam;

    React.useLayoutEffect(() => {
        if (ref.current) {
            ref.current.srcObject = videoStream || null;
        }
    }, [videoStream]);

    const handleSwitch = React.useCallback(() => {
        if (!onSwitch) return;

        if (isWebCam) {
            onSwitch(VideoType.Screen);
            return;
        }

        onSwitch(VideoType.Cam);
    }, [videoType]);

    React.useEffect(() => {
        if (connectionLost && ref.current) {
            ref.current.load();
        }
    }, [connectionLost]);

    const onFullScreenButtonClick = () => {
        if (ref && ref.current) {
            if (ref.current.requestFullscreen) {
                ref.current.requestFullscreen();
                // @ts-ignore
            } else if (ref.current.mozRequestFullScreen) { /* Firefox */
                // @ts-ignore
                ref.current.mozRequestFullScreen();
                // @ts-ignore
            } else if (ref.current.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
                // @ts-ignore
                ref.current.webkitRequestFullscreen();
                // @ts-ignore
            } else if (ref.current.msRequestFullscreen) { /* IE/Edge */
                // @ts-ignore
                ref.current.msRequestFullscreen();
            }
        }
    };


    return (
        <>
            <div className={cn(styles.video_container, containerClassName)}>
                {(processing || !videoStream) && !props.poster && (
                    <Loader
                      className={styles.loader}
                    />
                )}
                {(connectionLost) && (
                    <div className={styles.connectionLost} onClick={(e: any) => props.onClick && props.onClick(e)}>
                        <img src={ExclamationIcon} alt="ExclamationIcon" />
                    Соискатель не транслирует видео
                    </div>
                )}
                <video
                  autoPlay
                  muted={muted}
                  ref={ref}
                  {...props}
                  className={cn(styles.video, props.className)}
                >
                    <track kind="captions" srcLang="ru" label="Russian" />
                </video>
                {!withoutFullScreen ? <img src={FullScreenIcon} alt="FullScreenIcon" className={styles.fullScreenButton} onClick={onFullScreenButtonClick} /> : null}
            </div>
            {camSwitch && (
                <div className={styles.switchContainer}>
                    <span
                      className={cn(
                            styles.switchContainer_text, 'pr-2',
                            { [styles.switchContainer_text_secondary]: isWebCam },
                        )}
                    >
                        Рабочий стол
                    </span>
                    <WebCamSwitch
                      darkness
                      value={isWebCam}
                      name="onlineModalSwitch"
                      onClick={handleSwitch}
                      webCam={isWebCam}
                    />
                    <span
                      className={cn(
                            styles.switchContainer_text, 'pl-2',
                            { [styles.switchContainer_text_secondary]: !isWebCam },
                        )}
                    >
                        Веб-камера
                    </span>
                </div>
            )}
        </>
    );
};

export default UserVideo;

type UserVideoPropsType = IProps & React.DetailedHTMLProps<React.VideoHTMLAttributes<HTMLVideoElement>, HTMLVideoElement>

interface IProps extends React.RefAttributes<HTMLVideoElement> {
    videoStream?: MediaStream;
    processing?: boolean;
    containerClassName?: string;
    camSwitch?: boolean;
    withoutFullScreen?: boolean;
    videoType?: VideoType;
    connectionLost?: boolean;
    onSwitch?: (type: VideoType) => void;
}
